<script setup lang="ts">
import unicheckInformationImage from '@/assets/images/qaEquipment/UNICHECK-Connection-Information.png';
import Dialog from '@/components/Dialog/Dialog.vue';
import { success } from '@/components/icons/icons.ts';
import { mdiEmail, mdiPhone } from '@mdi/js';

type UnicheckDeviceOfflineInfoDialogProps = {
  isOffline: boolean;
  modelValue: boolean;
};

defineProps<UnicheckDeviceOfflineInfoDialogProps>();

defineEmits<{
  'update:modelValue': [value: boolean];
}>();
</script>

<template>
  <Dialog
    :modelValue="modelValue"
    aria-label="RequestAssignmentDialog"
    maxWidth="480"
    @update:modelValue="$emit('update:modelValue', $event)"
  >
    <template #title>{{ $t('SwitchOnUnicheckAndConnectWithPtw100') }}</template>
    <template #text>
      <div class="d-flex justify-end">
        <v-img
          class="my-8"
          alt="UNICHECK connection information"
          :src="unicheckInformationImage"
          maxWidth="90%"
        />
      </div>
      <p class="mb-4">{{ $t('SwitchOnTheDeviceMsg') }}</p>
      <template v-if="isOffline">
        <h4 class="mt-8">
          {{ $t('ContactPtwCustomerSupport') }}
        </h4>
        <div class="d-flex align-center mb-4">
          <v-icon :icon="mdiPhone" class="text-secondary mr-2"></v-icon>
          <span>+49 761 49055-0</span>
        </div>
        <div class="d-flex align-center">
          <v-icon :icon="mdiEmail" class="text-secondary mr-2"></v-icon>
          <span>support@ptwdosimetry.com</span>
        </div>
      </template>
      <v-alert
        v-else
        class="v-alert-overwrite mt-8 text-left"
        type="success"
        :icon="success"
        :text="$t('YourUnicheckDeviceIsOnlineMsg')"
      ></v-alert>
    </template>
    <template #actions>
      <VSpacer />
      <PrimaryVBtn
        :text="$t('Ok')"
        class="align-self-end"
        minWidth="8rem"
        @click="() => $emit('update:modelValue', false)"
      />
    </template>
  </Dialog>
</template>
